
import { useState } from 'react';
import AcquirerDataPanel from '@/components/adelantos/AcquirerDataPanel';
import { adminHttpClient } from '@/admin/lib/admin-http-client';
import { getAdminEndpointUrl } from '@/admin/lib/admin-api-config';

interface Acquirer {
  slug: string;
  id?: string;
  name: string;
  activated: boolean;
}

/**
 * Sección "Movimientos y cuotas" para el panel admin dentro de la ficha de un comercio.
 * Reusa `AcquirerDataPanel` pasando los endpoints admin.
 */
export default function AdminAcquirerDataSection({ companyId, acquirers }: { companyId: string; acquirers: Acquirer[] }) {
  const eligible = acquirers.filter((a) => a.activated && a.id);
  const [selected, setSelected] = useState<string>(eligible[0]?.id ?? '');

  if (eligible.length === 0) {
    return (
      <section className="rounded-xl border bg-card p-6">
        <h3 className="text-base font-semibold">Movimientos y cuotas por adquirente</h3>
        <p className="mt-2 text-sm text-muted-foreground">El comercio no tiene adquirentes activados todavía.</p>
      </section>
    );
  }

  return (
    <div className="space-y-4">
      {eligible.length > 1 && (
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium">Adquirente:</label>
          <select value={selected} onChange={(e) => setSelected(e.target.value)} className="rounded-md border border-input bg-background px-3 py-2 text-sm">
            {eligible.map((a) => (
              <option key={a.id} value={a.id}>{a.name}</option>
            ))}
          </select>
        </div>
      )}
      {selected && (
        <AcquirerDataPanel
          title="Movimientos y cuotas por adquirente"
          description="Lo que el scrapper sincronizó para este comercio. Útil para auditoría y soporte."
          acquirerId={selected}
          buildUrl={(resource) => getAdminEndpointUrl('acquirerData', resource, { companyId, acquirerId: selected })}
          fetcher={(url) => adminHttpClient.get(url)}
          advanceLinkPrefix="/admin/solicitudes/detalle?id="
        />
      )}
    </div>
  );
}
